import { Heading, BodyProps } from '@hover/blueprint';
import { Link as ChakraLink } from '@hover/blueprint/chakra';
import React, { FC } from 'react';
import { Link as GatsbyLink } from 'gatsby';

interface Props extends BodyProps {
  isBold?: boolean;
  to?: string;
  label: string;
}
const NavbarMobileLink: FC<Props> = ({ isBold, label, to, color, ...rest }) =>
  to && to.includes('/login') ? (
    <ChakraLink href={to} key={label}>
      <Heading
        color={color ?? 'neutral.700'}
        textTransform="capitalize"
        size={400}
        marginBottom={0}
        fontWeight={isBold ? '600' : 'normal'}
        {...rest}
      >
        {label}
      </Heading>
    </ChakraLink>
  ) : (
    <Heading
      key={label}
      to={to}
      as={GatsbyLink}
      color={color ?? 'neutral.700'}
      textTransform="capitalize"
      size={400}
      marginBottom={0}
      fontWeight={isBold ? '600' : 'normal'}
      {...rest}
    >
      {label}
    </Heading>
  );

NavbarMobileLink.defaultProps = {
  isBold: false,
  to: '#',
};

export default NavbarMobileLink;
